import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-details-trailer',
  templateUrl: './details-trailer.component.html',
  styleUrls: ['./details-trailer.component.css'],
})
export class DetailsTrailerComponent implements OnInit {
  isLoading: Boolean = true;

  trailerId: string;
  trailer: any = {};

  offers: any;

  @ViewChild('pdfContent') pdfContent!: ElementRef;
  isGeneratingPDF = false;

  constructor(
    private route: ActivatedRoute,
    private cmdsService: CommandesService,
    private decimalPipe: DecimalPipe,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.trailerId = params.trailerId;
      // this._fetchTrailer();
      this.generateTrailer();
    });
  }

  // _fetchTrailer() {
  //   this.cmdsService.getOneTrailer(this.trailerId).then((data: any) => {
  //     console.log('getOneTrailer :: ');
  //     console.log(data);
  //     if (data) {
  //       this.isLoading = false;
  //       this.trailer = data;
  //     } else {
  //       alert('Aucune remorque valide');
  //       location.href = '/all-trailers';
  //     }
  //   });
  // }

  generateTrailer() {
    this.cmdsService.generateTrailer(this.trailerId).then((result: any) => {
      // console.log('generateTrailer :: ');
      // console.log(result);
      if (result.response && result.data) {
        this.isLoading = false;
        this.trailer = result.data;
      } else {
        alert(result.msg || 'Aucune remorque valide');
        location.href = '/all-trailers';
      }
    });
  }

  getTotalPurchaseOrder(invoiceTaxes, totalCost) {
    return invoiceTaxes?.reduce((acc, item) => acc + item.value, 0) + totalCost;
  }

  async generatePdf() {
    this.isGeneratingPDF = true;

    try {
      const element = this.pdfContent.nativeElement;

      // Options pour html2canvas
      const options = {
        scale: 2,
        logging: false,
        allowTaint: false,
        useCORS: true,
        backgroundColor: '#ffffff',
        windowWidth: 1200, // Largeur fixe pour meilleure lisibilité
      };

      // Générer le canvas
      const canvas = await (html2canvas as any)(element, options);
      const imgData = canvas.toDataURL('image/png');

      // Créer le PDF (format A4)
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      // Calculer les dimensions pour que l'image tienne dans la page
      const imgWidth = 210; // Largeur A4 en mm
      const pageHeight = 297; // Hauteur A4 en mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Première page
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Pages supplémentaires si nécessaire
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Sauvegarder le PDF
      pdf.save(`trailer-${this.trailer?.remorqueId || 'export'}.pdf`);
    } catch (error) {
      console.error('Erreur lors de la génération du PDF:', error);
      // Optionnel: ajouter une notification d'erreur
      // alert('Erreur lors de la génération du PDF');
    } finally {
      this.isGeneratingPDF = false;
    }
  }

  private formatNumber(value: number): string {
    return this.decimalPipe.transform(value, '0.1-3')?.replace(',', '') ?? '0';
  }

  exportData(): void {
    const rows = [['Label', 'Valeur']];

    this?.trailer?.invoiceTaxes.forEach((item) => {
      rows.push([item.label, this.formatNumber(item?.value) + ' €']);
    });

    const totalCost = this.trailer?.totalCost ?? 0;
    rows.push(['Total removal cost', this.formatNumber(totalCost) + ' €']);

    const totalPurchaseOrder = this.getTotalPurchaseOrder(
      this.trailer?.invoiceTaxes,
      this.trailer?.totalCost,
    );
    rows.push([
      'Total Purchase Order',
      this.formatNumber(totalPurchaseOrder) + ' €',
    ]);

    const csvContent = rows.map((r) => r.join(';')).join('\n');
    const blob = new Blob(['\ufeff' + csvContent], {
      type: 'text/csv;charset=utf-8;',
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `trailer_123654_${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  }
}
